import { useState } from 'react'
import LandingPage from './LandingPage'
import BountyBoard from './BountyBoard'
import { ToastProvider } from './components/Toast'
import ErrorBoundary from './components/ErrorBoundary'
import './App.css'

function App() {
  const [hasEntered, setHasEntered] = useState(false)
  const [userEmail, setUserEmail] = useState('')
  const [userName, setUserName] = useState('')

  const handleEnter = (email = '', name = '') => {
    setUserEmail(email)
    setUserName(name)
    setHasEntered(true)
  }

  if (!hasEntered) {
    return (
      <ErrorBoundary>
        <LandingPage onEnter={handleEnter} />
      </ErrorBoundary>
    )
  }

  return (
    <ErrorBoundary>
      <div className="w-full h-full">
        <ToastProvider>
          <BountyBoard userEmail={userEmail} userName={userName} />
        </ToastProvider>
      </div>
    </ErrorBoundary>
  )
}

export default App
